import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import { AngleDownIcon } from '@wf-sl/common-icons'

import styles from './dropdown.module.css'

const propTypes = {
    disabled: PropTypes.bool,
    error: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    headerClassName: PropTypes.string,
    icon: PropTypes.object, // eslint-disable-line react/forbid-prop-types
    item: PropTypes.string,
    placeholder: PropTypes.string
}

const DropdownHeader = props => {
    const { disabled, error, headerClassName, icon, item, placeholder } = props
    const iconElement = icon ? <div className={styles['icon']}>{icon}</div> : null
    const composedClassName = cx(styles['header'], {
        [styles['disabled']]: disabled,
        [styles['error']]: error,
        [styles['placeholder']]: !item
    })
    return (
        <div className={composedClassName}>
            {iconElement}
            <span className={cx(styles['content'], headerClassName)}>{item || placeholder || 'Please select...'}</span>
            <AngleDownIcon className={styles['button']} />
        </div>
    )
}

DropdownHeader.propTypes = propTypes

export default DropdownHeader
